import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { getSplitInvite, signSplitInvite } from "@/lib/afmApi";

const assetUrl = (u) => (u && u.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

// Página pública: el artista de un manager firma su porcentaje real (sin crear cuenta).
export default function SplitAgreement() {
  const { token } = useParams();
  const [d, setD] = useState(undefined);
  const [name, setName] = useState("");
  const [accept, setAccept] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => { getSplitInvite(token).then(setD).catch(() => setD(null)); }, [token]);

  const sign = async () => {
    setErr("");
    setBusy(true);
    try { await signSplitInvite(token, { signer_name: name.trim(), accept }); setD({ ...d, status: "signed", signer_name: name.trim() }); }
    catch (e) { setErr(e?.response?.data?.detail || "No se pudo firmar"); } finally { setBusy(false); }
  };

  if (d === undefined) return <div className="flex min-h-screen items-center justify-center text-sm text-slate-400">Cargando…</div>;
  if (!d) return <div className="flex min-h-screen items-center justify-center text-sm text-slate-500">Este enlace no es válido o ya no está disponible.</div>;

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-4" data-testid="split-agreement">
      <div className="w-full max-w-md overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
        <div className="flex items-center gap-3 p-5 text-white" style={{ background: d.color_primary || "#CA0808" }}>
          {d.logo_url && <img src={assetUrl(d.logo_url)} alt="" className="h-10 w-10 rounded-lg bg-white/10 object-contain" />}
          <div><div className="text-xs uppercase tracking-wider text-white/80">Acuerdo de reparto</div><div className="font-semibold">{d.manager}</div></div>
        </div>
        <div className="space-y-4 p-6 text-sm text-slate-700">
          <p>Hola <strong>{d.artist}</strong>. Tu manager <strong>{d.manager}</strong> distribuye tu música con Always Fresh Music.</p>
          <div className="rounded-xl border border-slate-200 bg-slate-50 p-4 text-center">
            <div className="text-xs uppercase tracking-wider text-slate-500">Tu parte de las regalías</div>
            <div className="text-4xl font-bold text-black">{d.artist_pct}%</div>
            <div className="mt-1 text-xs text-slate-500">de lo que generen tus lanzamientos con {d.manager}, después de la comisión de distribución.</div>
          </div>
          {d.status === "signed" ? (
            <div className="flex items-center gap-2 rounded-lg border border-emerald-200 bg-emerald-50 p-3 text-emerald-800"><CheckCircle2 className="h-5 w-5" /> Firmado por {d.signer_name}. ¡Gracias!</div>
          ) : (
            <>
              <div>
                <label className="mb-1 block text-xs font-semibold text-slate-600">Tu nombre completo (como firma)</label>
                <input value={name} onChange={(e) => setName(e.target.value)} className="w-full rounded-lg border border-slate-300 px-3 py-2.5 outline-none focus:border-black" />
              </div>
              <label className="flex items-start gap-2 text-xs">
                <input type="checkbox" checked={accept} onChange={(e) => setAccept(e.target.checked)} className="mt-0.5" />
                <span>Acepto recibir el {d.artist_pct}% de las regalías de mis lanzamientos gestionados por {d.manager}, y que {d.manager} reciba los pagos y me liquide mi parte.</span>
              </label>
              {err && <p className="text-xs text-red-600">{err}</p>}
              <button onClick={sign} disabled={busy || !accept || name.trim().length < 3} className="w-full rounded-lg bg-black py-2.5 font-semibold text-white disabled:opacity-40">{busy ? "Firmando…" : "Firmar acuerdo"}</button>
              <p className="text-[11px] text-slate-400">Se guarda tu nombre, la fecha y la conexión desde donde firmas como constancia.</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
